import React from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/common";
import { TrackBox } from "@/components/TrackBox";
import { useMeta } from "@/hooks/useMeta";

export default function Track() {
  const [params] = useSearchParams();
  useMeta("Track Your Order | Somnio.Co");
  return (
    <div data-testid="track-page">
      <PageHeader eyebrow="Order Tracking" title="Track Your Order" intro="Enter your order number and the email used at checkout." />
      <div className="max-w-[1400px] mx-auto px-5 md:px-12"><TrackBox initialOrder={params.get("order") || ""} /></div>
    </div>
  );
}
